.ToggleLight {
    display: flex;
    align-items: center;
    gap: 14px;

    &.isOn {
        & .ToggleLight__switch {
            background: var(--soniq-t--global--background--color--status--success--default);
            border-color: var(--soniq-t--global--border--color--status--success--default);
        }

        & .ToggleLight__knob {
            transform: translateX(28px);
        }

        & .ToggleLight__lamp {
            background: var(--soniq-t--global--palette--neon-green);
            border-color: var(--soniq-t--global--border--color--status--success--default);
            box-shadow: 0 0 12px 2px var(--soniq-t--global--background--color--status--success--default);
        }

        & .ToggleLight__hint {
            color: var(--soniq-t--global--text--color--status--success--default);
        }
    }
}

.ToggleLight__switch {
    position: relative;
    width: 58px;
    height: 30px;
    border-radius: 999px;
    border: 1px solid var(--soniq-t--global--border--color--input--default);
    background: var(--soniq-t--global--background--color--surface--input);
    cursor: pointer;
    transition: background 150ms ease, border-color 150ms ease;

    &:focus-visible {
        outline: 2px solid var(--soniq-t--global--border--color--accent--today--default);
        outline-offset: 3px;
    }
}

.ToggleLight__knob {
    position: absolute;
    top: 3px;
    left: 3px;
    width: 22px;
    height: 22px;
    border-radius: 50%;
    background: var(--soniq-t--global--background--color--surface--panel-opaque);
    border: 1px solid var(--soniq-t--global--border--color--event--opaque);
    box-shadow: 0 2px 6px var(--soniq-t--global--text--shadow--subtle);
    transition: transform 150ms ease;
}

.ToggleLight__lamp {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: var(--soniq-t--global--background--color--status--muted--default);
    border: 1px solid var(--soniq-t--global--border--color--status--muted--default);
    transition: background 150ms ease, box-shadow 150ms ease;
}

.ToggleLight__text {
    display: flex;
    flex-direction: column;
    gap: 2px;
}

.ToggleLight__label {
    font-size: var(--soniq-t--global--font--size--body);
    font-weight: var(--soniq-t--global--font--weight--medium);
    color: var(--soniq-t--global--text--color--regular--default);
}

.ToggleLight__hint {
    font-size: var(--soniq-t--global--font--size--field-label);
    letter-spacing: var(--soniq-t--global--font--letter-spacing--wide);
    text-transform: uppercase;
    font-family: var(--soniq-t--global--font--family--mono);
    color: var(--soniq-t--global--text--color--secondary--default);
}

@media (prefers-reduced-motion: reduce) {
    .ToggleLight__switch,
    .ToggleLight__knob,
    .ToggleLight__lamp {
        transition: none;
    }
}
